import { render, staticRenderFns } from "./dialog-inboxapproved.vue?vue&type=template&id=664af8a1&"
import script from "./dialog-inboxapproved.vue?vue&type=script&lang=js&"
export * from "./dialog-inboxapproved.vue?vue&type=script&lang=js&"
import style0 from "./dialog-inboxapproved.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports